import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  title: string;
}

export function EditFavoriteSuccessToast(props: Props) {
  const {
    id,
    title,
  } = props

  const polyglot = usePolyglot()

  const body = polyglot.t(
    "toasts.edit_favorite_success.body",
    { title },
  )

  return (
    <Toast
      stylePreset="success"
      body={body}
      id={id}
    />
  )
}
